import React from "react";
import dayjs from "dayjs";

const BurialView = ({ currentRecord }) => {
  return (
    <div>
      <InfoTable jsonData={currentRecord} />
    </div>
  );
};

export default BurialView;

const InfoTable = ({ jsonData }) => {
  const dateFields = ["date_of_demise", "date_of_birth"];
  const keysToShow = Object.keys(jsonData).filter(
    (key) =>
      ![
        "__v",
        "id",
        "createdAt",
        "church_id",
        "createdBy",
        "updatedAt",
        "marriage_date",
        "_id",
      ].includes(key)
  );

  const formatDate = (dateString) => {
    return dayjs(dateString).utc().format("MM/DD/YYYY");
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse table-auto">
        <tbody>
          {keysToShow.map((key, index) => {
            const isDateField = dateFields.includes(key);
            const value = jsonData[key];
            const displayValue =
              isDateField && typeof value === "string"
                ? formatDate(value)
                : typeof value === "object" && value !== null
                ? value.label
                : value;

            return (
              <tr
                key={key}
                className={`${index % 2 === 0 ? "bg-white" : "bg-gray-200"}`}
              >
                <td className="px-4 py-2 font-medium text-black border">
                  {key
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (l) => l.toUpperCase())}
                </td>
                <td className="px-4 py-2 text-black border">{displayValue}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
